{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartLegendEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

  {$IFDEF VCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
  CHECKBOXSIZE = 17;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
  BIGLBLSPACE = 30;
  SMALLHORSPACE = 60;
  MIDHORSPACE = 70;
  BIGHORSPACE = 80;
//  SERIESLARGECONTROLWIDTH = 100;
  LARGECONTROLWIDTH = 100;
  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;


resourcestring
  sTMSFNCChartLegendEditorOK = 'OK';
  sTMSFNCChartLegendEditorCancel = 'Cancel';

  sTMSFNCChartLegendEditorLegend = 'Legend';
  sTMSFNCChartLegendEditorValue = 'Value';
  sTMSFNCChartLegendEditorFill = 'Fill';
  sTMSFNCChartLegendEditorStroke = 'Stroke';
  sTMSFNCChartLegendEditorColor = 'Color';
  sTMSFNCChartLegendEditorColorTo = 'Color To';
  sTMSFNCChartLegendEditorVisible = 'Visible';
  sTMSFNCChartLegendEditorKind = 'Kind';
  sTMSFNCChartLegendEditorGradient = 'Gradient';
  sTMSFNCChartLegendEditorOpacity = 'Opacity';
  sTMSFNCChartLegendEditorWidth = 'Width';
  sTMSFNCChartLegendEditorPosition = 'Position';
  sTMSFNCChartLegendEditorName = 'Name';
  sTMSFNCChartLegendEditorOffsetY = 'Offset Y';
  sTMSFNCChartLegendEditorOffsetX = 'Offset X';
  sTMSFNCChartLegendEditorFont = 'Font';
  sTMSFNCChartLegendEditorSize = 'Size';

  sTMSFNCChartLegendEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartLegendEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
type
  TTMSFNCChartLegendEditor = class;

  {$IFDEF FMXLIB}
  TTMSFNCChartLegendEditorParent = TFmxObject;
  TTMSFNCChartLegendEditorComboBox = class(TComboBox);
  TTMSFNCChartLegendEditorSpinEdit = class(TSpinBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  TTMSFNCChartLegendEditorColorCombo = class(TComboColorBox);
  TTMSFNCChartLegendEditorAlphaTrackBar = class(TAlphaTrackBar);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartLegendEditorParent = TWinControl;
  TTMSFNCChartLegendEditorComboBox = class(TComboBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  {$IFNDEF LCLLIB}
  TTMSFNCChartLegendEditorSpinEdit = class(TSpinEdit);
  {$ENDIF}
  {$IFDEF LCLLIB}
  TTMSFNCChartLegendEditorSpinEdit = class(TFloatSpinEdit);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCChartLegendEditorColorCombo = class(TColorBox);
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCChartLegendEditorColorCombo = class(TWebColorPicker);
  {$ENDIF}
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartLegendEditor = class(TTMSFNCCustomComponent)
  private
    FBitmapEditor: TTMSFNCBitmapEditor;
    {$IFNDEF FMXLIB}
    FVertScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVertScrlBox: TVertScrollBox;
    FLegFillOpacity, FLegStrokeOpacity: TTMSFNCChartLegendEditorAlphaTrackBar;
    {$ENDIF}
    FLegendPanel:TTMSFNCEditorPanel;

    FLegFillCol1, FLegFillCol2, FLegStrokeCol, FLegFontCol: TTMSFNCChartLegendEditorColorCombo;
    FLegFillKind, FLegGradientKind, FLegStrokeKind, FLegValue, FLegFontName: TTMSFNCChartLegendEditorComboBox;
    FLegAppLeft, FLegAppTop, FLegSize, FLegStrokeWidth :TTMSFNCChartLegendEditorSpinEdit;
    FLegVisibleCheck: TCheckBox;

    frm: TTMSFNCCustomDesignerForm;
    FPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FModified: Boolean;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
  protected
    {$IFDEF CMNWEBLIB}
    procedure SetColorComboStyle(AColorcombo: TTMSFNCChartLegendEditorColorCombo);
    {$ENDIF}
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartLegendEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    procedure FillFonts;
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure DoLegAppPosChange(Sender: TObject); virtual;
    procedure DoLegAppFillChange(Sender: TObject); virtual;
    procedure DoLegAppStrokeChange(Sender: TObject); virtual;
    procedure DoLegAppFontChange(Sender: TObject); virtual;
    procedure CreateBottomPanel(AParent: TTMSFNCChartLegendEditorParent);
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
  end;

  TTMSFNCChartLegendEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartLegendEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartLegendEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartLegendEditorDialog = class(TTMSFNCChartLegendEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,VCL.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;
//{$R TMSFNCChartLegendEditor.res}

type
  TTMSFNCChartOpen = class(TTMSFNCChart);

{ TTMSFNCChartLegendEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartLegendEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartLegendEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartLegendEditor);
end;

procedure TTMSFNCChartLegendEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartLegendEditor) then
    FChart := (Source as TTMSFNCChartLegendEditor).Chart;
end;

procedure TTMSFNCChartLegendEditor.BuildEditor(AParent: TTMSFNCChartLegendEditorParent);
var
  lbl1, lbl2, lbl3, lbl4, lbl5: TLabel;
begin
  if Assigned(AParent) then
  begin
    {$IFDEF FMXLIB}
    FVertScrlBox := TVertScrollBox.Create(AParent);
    FVertScrlBox.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FVertScrlBox := TScrollBox.Create(AParent);
    FVertScrlBox.Align := alClient;
    FVertScrlBox.Top := 0;
    {$IFDEF LCLLIB}
    FVertScrlBox.HorzScrollBar.Visible:= False;
    {$ENDIF}
    {$ENDIF}
    FVertScrlBox.Parent := AParent;
    {$IFDEF CMNWEBLIB}
    FVertScrlBox.BorderStyle := bsNone;
    if IsLightTheme then
      FVertScrlBox.Color := EDITORSUBBACKCOLORLIGHT
    else
      FVertScrlBox.Color := EDITORSUBBACKCOLORDARK;
    {$ENDIF}


    //                  Legend Panel
    //**************************************************
    FLegendPanel := TTMSFNCEditorPanel.Create(AParent);
    FLegendPanel.PanelPosition := eppCenter;
    {$IFDEF FMXLIB}
    FLegendPanel.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegendPanel.Align := alClient;
    {$ENDIF}
    FLegendPanel.Parent := AParent;

    lbl1 := TLabel.Create(FLegendPanel);
    lbl1.Parent := FLegendPanel;
    lbl1.AutoSize := True;
    {$IFDEF FMXLIB}
    lbl1.Position.X := MIDLBLSPACE;
    lbl1.Position.Y := BIGHEIGHTSPAC;
    lbl1.Text := TranslateTextEx(sTMSFNCChartLegendEditorLegend);
    lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
    lbl1.Font.Size := 18;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl1.Left := MIDLBLSPACE;
    lbl1.Top := BIGHEIGHTSPAC;
    lbl1.Caption := TranslateTextEx(sTMSFNCChartLegendEditorLegend);
    lbl1.Font.Size := 15;
    {$ENDIF}
    lbl1.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl1);

    lbl2 := TLabel.Create(FLegendPanel);
    lbl2.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
    lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartLegendEditorPosition);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl1.Left + SMALLLBLSPACE;
    lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartLegendEditorPosition);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorValue);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorValue);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FLegValue := TTMSFNCChartLegendEditorComboBox.Create(FLegendPanel);
    FLegValue.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegValue.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FLegValue.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegValue.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegValue.Left := lbl3.Left + SMALLHORSPACE;
    FLegValue.Top := lbl3.Top + (lbl3.Height - FLegValue.Height) div 2;
    {$ENDIF}
    FLegValue.Items.Add('Top Left');
    FLegValue.Items.Add('Top Center');
    FLegValue.Items.Add('Top Right');
    FLegValue.Items.Add('Center Left');
    FLegValue.Items.Add('Center Center');
    FLegValue.Items.Add('Center Right');
    FLegValue.Items.Add('Bottom Left');
    FLegValue.Items.Add('Bottom Center');
    FLegValue.Items.Add('Bottom Right');
    FLegValue.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FLegendPanel);
    lbl4.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartLegendEditorOffsetX);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartLegendEditorOffsetX);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FLegAppLeft := TTMSFNCChartLegendEditorSpinEdit.Create(FLegendPanel);
    FLegAppLeft.Parent := FLegendPanel;

    {$IFDEF FMXLIB}
    FLegAppLeft.DecimalDigits := 1;
    FLegAppLeft.Position.X := FLegValue.Position.X;
    FLegAppLeft.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegAppLeft.Height)/2;
    FLegAppLeft.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegAppLeft.Left := FLegValue.Left;
    FLegAppLeft.Top := lbl4.Top + (lbl4.Height - FLegAppLeft.Height) div 2;
    {$ENDIF}
    FLegAppLeft.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorOffsetY);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorOffsetY);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FLegAppTop := TTMSFNCChartLegendEditorSpinEdit.Create(FLegendPanel);
    FLegAppTop.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegAppTop.DecimalDigits := 1;
    FLegAppTop.Position.X := FLegAppLeft.Position.X;
    FLegAppTop.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegAppTop.Height)/2;
    FLegAppTop.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegAppTop.Left := FLegAppLeft.Left;
    FLegAppTop.Top := lbl3.Top + (lbl3.Height - FLegAppTop.Height) div 2;
    {$ENDIF}
    FLegAppTop.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FLegendPanel);
    lbl4.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartLegendEditorVisible);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartLegendEditorVisible);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FLegVisibleCheck := TCheckBox.Create(FLegendPanel);
    FLegVisibleCheck.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegVisibleCheck.Position.X := FLegAppTop.Position.X;
    FLegVisibleCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegVisibleCheck.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegVisibleCheck.Height := CHECKBOXSIZE;
    FLegVisibleCheck.Width := CHECKBOXSIZE;
    FLegVisibleCheck.Left := FLegAppTop.Left;
    FLegVisibleCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
    {$ENDIF}

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := FLegAppLeft.Position.X + FLegAppLeft.Width + BIGLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorFill);
    lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := FLegAppLeft.Left + FLegAppLeft.Width + BIGLBLSPACE;
    lbl3.Top := lbl2.Top;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorFill);
    {$ENDIF}
    lbl3.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl3);

    lbl2 := TLabel.Create(FLegendPanel);
    lbl2.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl3.Position.X + MIDLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartLegendEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl3.Left + MIDLBLSPACE;
    lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartLegendEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl2);

    FLegFillCol1 := TTMSFNCChartLegendEditorColorCombo.Create(FLegendPanel);
    FLegFillCol1.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
    FLegFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegFillCol1.Height)/2;
    FLegFillCol1.Width := SMALLCONTROLWIDTH;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FLegFillCol1);
    FLegFillCol1.Width := LARGECONTROLWIDTH;
    FLegFillCol1.Left := lbl2.Left + SMALLHORSPACE;
    FLegFillCol1.Top := lbl2.Top + (lbl2.Height - FLegFillCol1.Height) div 2;
    {$ENDIF}

    {$IFDEF CMNWEBLIB}
    lbl5 := TLabel.Create(FLegendPanel);
    lbl5.Parent := FLegendPanel;
    lbl5.Left := lbl2.Left;
    lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartLegendEditorColorTo);
    SetEditorLabelAppearance(lbl5);
    {$ENDIF}

    FLegFillCol2 := TTMSFNCChartLegendEditorColorCombo.Create(FLegendPanel);
    FLegFillCol2.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegFillCol2.Position.X := FLegFillCol1.Position.X + FLegFillCol1.Width + SMALLLBLSPACE;
    FLegFillCol2.Position.Y := FLegFillCol1.Position.Y;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FLegFillCol2);
    FLegFillCol2.Left := FLegFillCol1.Left;
    FLegFillCol2.Top := lbl5.Top + (lbl5.Height - FLegFillCol2.Height) div 2;
    {$ENDIF}
    FLegFillCol2.Width := FLegFillCol1.Width;

    lbl4 := TLabel.Create(FLegendPanel);
    lbl4.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl2.Position.X;
    lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartLegendEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl2.Left;
    lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartLegendEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FLegFillKind := TTMSFNCChartLegendEditorComboBox.Create(FLegendPanel);
    FLegFillKind.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegFillKind.Position.X := FLegFillCol1.Position.X;
    FLegFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegFillKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegFillKind.Left := FLegFillCol1.Left;
    FLegFillKind.Top := lbl4.Top + (lbl4.Height - FLegFillKind.Height) div 2;
    {$ENDIF}
    FLegFillKind.Items.Add('None');
    FLegFillKind.Items.Add('Solid');
    FLegFillKind.Items.Add('Gradient');
    FLegFillKind.Width := LARGECONTROLWIDTH;

    lbl5 := TLabel.Create(FLegendPanel);
    lbl5.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl5.Position.X := lbl4.Position.X;
    lbl5.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl5.Text := TranslateTextEx(sTMSFNCChartLegendEditorGradient);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl5.Left := lbl4.Left;
    lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl5.Caption := TranslateTextEx(sTMSFNCChartLegendEditorGradient);
    {$ENDIF}
    SetEditorLabelAppearance(lbl5);

    FLegGradientKind := TTMSFNCChartLegendEditorComboBox.Create(FLegendPanel);
    FLegGradientKind.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegGradientKind.Position.X := FLegFillCol1.Position.X;
    FLegGradientKind.Position.Y := lbl5.Position.Y + (lbl5.Height - FLegGradientKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegGradientKind.Left := FLegFillCol1.Left;
    FLegGradientKind.Top := lbl5.Top + (lbl5.Height - FLegGradientKind.Height) div 2;
    {$ENDIF}
    FLegGradientKind.Items.Add('Horizontal');
    FLegGradientKind.Items.Add('Vertical');
    FLegGradientKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FLegendPanel);
    lbl2.Parent := FLegendPanel;
    lbl2.Position.X := lbl5.Position.X;
    lbl2.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartLegendEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FLegFillOpacity := TTMSFNCChartLegendEditorAlphaTrackBar.Create(FLegendPanel);
    FLegFillOpacity.Parent := FLegendPanel;
    FLegFillOpacity.Position.X := FLegFillKind.Position.X;
    FLegFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegFillOpacity.Height)/2;
    FLegFillOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl2 := TLabel.Create(FLegendPanel);
    lbl2.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := FLegFillOpacity.Position.X + FLegFillOpacity.Width + BIGLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y;
    lbl2.Text := TranslateTextEx(sTMSFNCChartLegendEditorStroke);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := FLegFillKind.Left + FLegFillKind.Width + BIGLBLSPACE;
    lbl2.Top := lbl3.Top;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartLegendEditorStroke);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FLegStrokeCol := TTMSFNCChartLegendEditorColorCombo.Create(FLegendPanel);
    FLegStrokeCol.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
    FLegStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegStrokeCol.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FLegStrokeCol);
    FLegStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
    FLegStrokeCol.Top := lbl3.Top + (lbl3.Height - FLegStrokeCol.Height) div 2;
    {$ENDIF}
    FLegStrokeCol.Width := FLegFillCol1.Width;

    lbl4 := TLabel.Create(FLegendPanel);
    lbl4.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartLegendEditorKind);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartLegendEditorKind);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FLegStrokeKind := TTMSFNCChartLegendEditorComboBox.Create(FLegendPanel);
    FLegStrokeKind.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegStrokeKind.Position.X := FLegStrokeCol.Position.X;
    FLegStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegStrokeKind.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegStrokeKind.Left := FLegStrokeCol.Left;
    FLegStrokeKind.Top := lbl4.Top + (lbl4.Height - FLegStrokeKind.Height) div 2;
    {$ENDIF}
    FLegStrokeKind.Items.Add('None');
    FLegStrokeKind.Items.Add('Solid');
    FLegStrokeKind.Items.Add('Dash');
    FLegStrokeKind.Items.Add('Dot');
    FLegStrokeKind.Items.Add('DashDot');
    FLegStrokeKind.Items.Add('DashDotDot');
    FLegStrokeKind.Width := LARGECONTROLWIDTH;

    {$IFDEF FMXLIB}
    lbl2 := TLabel.Create(FLegendPanel);
    lbl2.Parent := FLegendPanel;
    lbl2.Position.X := lbl4.Position.X;
    lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartLegendEditorOpacity);
    SetEditorLabelAppearance(lbl2);

    FLegStrokeOpacity := TTMSFNCChartLegendEditorAlphaTrackBar.Create(FLegendPanel);
    FLegStrokeOpacity.Parent := FLegendPanel;
    FLegStrokeOpacity.Position.X := FLegStrokeKind.Position.X;
    FLegStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegStrokeOpacity.Height)/2;
    FLegStrokeOpacity.Width := LARGECONTROLWIDTH;
    {$ENDIF}

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorWidth);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorWidth);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FLegStrokeWidth := TTMSFNCChartLegendEditorSpinEdit.Create(FLegendPanel);
    FLegStrokeWidth.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegStrokeWidth.Min := 0;
    FLegStrokeWidth.DecimalDigits := 1;
    FLegStrokeWidth.Position.X := FLegStrokeOpacity.Position.X;
    FLegStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegStrokeWidth.Height)/2;
    FLegStrokeWidth.ValueType := TNumValuetype.Float;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegStrokeWidth.MinValue := 0;
    FLegStrokeWidth.Left := FLegStrokeKind.Left;
    FLegStrokeWidth.Top := lbl3.Top + (lbl3.Height - FLegStrokeWidth.Height) div 2;
    {$ENDIF}
    FLegStrokeWidth.Width := LARGECONTROLWIDTH;

    lbl2 := TLabel.Create(FLegendPanel);
    lbl2.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
    lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + BIGHEIGHTSPAC;
    lbl2.Text := TranslateTextEx(sTMSFNCChartLegendEditorFont);
    lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl2.Left := lbl1.Left + SMALLLBLSPACE;
    lbl2.Top := FLegVisibleCheck.Top + FLegVisibleCheck.Height + BIGHEIGHTSPAC;
    lbl2.Caption := TranslateTextEx(sTMSFNCChartLegendEditorFont);
    {$ENDIF}
    lbl2.Font.Style := [TFontStyle.fsBold];
    SetEditorLabelAppearance(lbl2);

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
    lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorName);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl2.Left + MIDLBLSPACE;
    lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorName);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FLegFontName := TTMSFNCChartLegendEditorComboBox.Create(FLegendPanel);
    FLegFontName.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegFontName.Position.X := FLegValue.Position.X;
    FLegFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegFontName.Height)/2;
    FLegFontName.ItemWidth := 240;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegFontName.Left := FLegValue.Left;
    FLegFontName.Top := lbl3.Top + (lbl3.Height - FLegFontName.Height) div 2;
    {$ENDIF}
    FLegFontName.Width := LARGECONTROLWIDTH;

    lbl4 := TLabel.Create(FLegendPanel);
    lbl4.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl4.Position.X := lbl3.Position.X;
    lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Text := TranslateTextEx(sTMSFNCChartLegendEditorColor);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl4.Left := lbl3.Left;
    lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
    lbl4.Caption := TranslateTextEx(sTMSFNCChartLegendEditorColor);
    {$ENDIF}
    SetEditorLabelAppearance(lbl4);

    FLegFontCol := TTMSFNCChartLegendEditorColorCombo.Create(FLegendPanel);
    FLegFontCol.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegFontCol.Position.X := FLegValue.Position.X;
    FLegFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegFontCol.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    SetColorComboStyle(FLegFontCol);
    FLegFontCol.Left := FLegValue.Left;
    FLegFontCol.Top := lbl4.Top + (lbl4.Height - FLegFontCol.Height) div 2;
    {$ENDIF}
    FLegFontCol.Width := LARGECONTROLWIDTH;

    lbl3 := TLabel.Create(FLegendPanel);
    lbl3.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    lbl3.Position.X := lbl4.Position.X;
    lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Text := TranslateTextEx(sTMSFNCChartLegendEditorSize);
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    lbl3.Left := lbl4.Left;
    lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
    lbl3.Caption := TranslateTextEx(sTMSFNCChartLegendEditorSize);
    {$ENDIF}
    SetEditorLabelAppearance(lbl3);

    FLegSize := TTMSFNCChartLegendEditorSpinEdit.Create(FLegendPanel);
    FLegSize.Parent := FLegendPanel;
    {$IFDEF FMXLIB}
    FLegSize.Min := 0;
    FLegSize.Position.X := FLegAppLeft.Position.X;
    FLegSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSize.Height)/2;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FLegSize.MinValue := 0;
    FLegSize.Left := FLegFontCol.Left;
    FLegSize.Top := lbl3.Top + (lbl3.Height - FLegSize.Height) div 2;
    {$ENDIF}
    FLegSize.Width := LARGECONTROLWIDTH;



    //                     Bottom Panel
    //-------------------------------------------------------

    CreateBottomPanel(AParent);

    FillFonts;
    Initialize;
    SetAppearance;
  end;
end;

procedure TTMSFNCChartLegendEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartLegendEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartLegendEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartLegendEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartLegendEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

constructor TTMSFNCChartLegendEditor.Create(AOwner: TComponent);
begin
  inherited;
  FBitmapEditor := TTMSFNCBitmapEditor.Create(Self);
end;

procedure TTMSFNCChartLegendEditor.CreateBottomPanel(AParent: TTMSFNCChartLegendEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartLegendEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartLegendEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;
end;

destructor TTMSFNCChartLegendEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartLegendEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartLegendEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

procedure TTMSFNCChartLegendEditor.DoLegAppFillChange(Sender: TObject);
begin
  FChart.Legend.Fill.Kind := TTMSFNCGraphicsFillKind(FLegFillKind.ItemIndex);
  FChart.Legend.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FLegGradientKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Legend.Fill.Color := FLegFillCol1.Color;
  FChart.Legend.Fill.ColorTo := FLegFillCol2.Color;
  FChart.Legend.Fill.Opacity := FLegFillOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Legend.Fill.Color := FLegFillCol1.Selected;
  FChart.Legend.Fill.ColorTo := FLegFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartLegendEditor.DoLegAppFontChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Legend.Font.Color := FLegFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Legend.Font.Color := FLegFontCol.Selected;
  {$ENDIF}
  FChart.Legend.Font.Name := FLegFontName.Items[FLegFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Legend.Font.Size := FLegSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Legend.Font.Size := Round(FLegSize.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartLegendEditor.DoLegAppPosChange(Sender: TObject);
begin
  FChart.Legend.Position := TTMSFNCChartLegendPosition(FLegValue.ItemIndex);
  FChart.Legend.Left := FLegAppLeft.Value;
  FChart.Legend.Top := FLegAppTop.Value;
  {$IFDEF FMXLIB}
  FChart.Legend.Visible := FLegVisibleCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Legend.Visible := FLegVisibleCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartLegendEditor.DoLegAppStrokeChange(Sender: TObject);
begin
  {$IFNDEF FMXLIB}
  FChart.Legend.Stroke.Color := FLegStrokeCol.Selected;
  {$ENDIF}
  FChart.Legend.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FLegStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Legend.Stroke.Color := FLegStrokeCol.Color;
  FChart.Legend.Stroke.Opacity := FLegStrokeOpacity.Value;
  {$ENDIF}
  FChart.Legend.Stroke.Width := FLegStrokeWidth.Value;

  FModified := True;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartLegendEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartLegendEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartLegendEditorForm.CreateDialogNew(Self, 'Chart Legend Editor');
  {$ELSE}
  frm := TTMSFNCChartLegendEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Legend Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 730;
  frm.Height := 520;
  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  frm.OnKeyDown := @DoFormKeyDown;
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  frm.ActiveControl := FLegendPanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

procedure TTMSFNCChartLegendEditor.FillFonts;
var
  sl: TStringList;
begin
  sl := TStringList.Create;
  try
    TTMSFNCUtils.GetFonts(sl);
    FLegFontName.Items.Assign(sl);

  finally
    sl.Free;
  end;
end;

function TTMSFNCChartLegendEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartLegendEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartLegendEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartLegendEditor.Initialize;
begin
 FLegValue.ItemIndex := Integer(FChart.Legend.Position);
  {$IFDEF FMXLIB}
  FLegAppLeft.Value := FChart.Legend.Left;
  FLegAppTop.Value := FChart.Legend.Top;
  FLegVisibleCheck.IsChecked := FChart.Legend.Visible;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegAppLeft.Value := Round(FChart.Legend.Left);
  FLegAppTop.Value := Round(FChart.Legend.Top);
  FLegVisibleCheck.Checked := FChart.Legend.Visible;
  {$ENDIF}

  FLegFillKind.ItemIndex := Integer(FChart.Legend.Fill.Kind);
  FLegGradientKind.ItemIndex := Integer(FChart.Legend.Fill.GradientOrientation);
  {$IFDEF FMXLIB}
  FLegFillCol1.Color := FChart.Legend.Fill.Color;
  FLegFillCol2.Color := FChart.Legend.Fill.ColorTo;
  FLegFillOpacity.Value := FChart.Legend.Fill.Opacity;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegFillCol1.Selected := FChart.Legend.Fill.Color;
  FLegFillCol2.Selected := FChart.Legend.Fill.ColorTo;
  {$ENDIF}

  FLegStrokeKind.ItemIndex := Integer(FChart.Legend.Stroke.Kind);
  {$IFDEF FMXLIB}
  FLegStrokeCol.Color := FChart.Legend.Stroke.Color;
  FLegStrokeOpacity.Value := FChart.Legend.Stroke.Opacity;
  FLegStrokeWidth.Value := FChart.Legend.Stroke.Width;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegStrokeCol.Selected := FChart.Legend.Stroke.Color;
  FLegStrokeWidth.Value := Trunc(FChart.Legend.Stroke.Width);
  {$ENDIF}

  {$IFDEF FMXLIB}
  FLegFontCol.Color := FChart.Legend.Font.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegFontCol.Selected := FChart.Legend.Font.Color;
  {$ENDIF}
  FLegFontName.ItemIndex := FLegFontName.Items.IndexOf(FChart.Legend.Font.Name);
  FLegSize.Value := FChart.Legend.Font.Size;

  FLegValue.OnChange := @DoLegAppPosChange;
  FLegAppLeft.OnChange := @DoLegAppPosChange;
  FLegAppTop.OnChange := @DoLegAppPosChange;


  FLegFillKind.OnChange := @DoLegAppFillChange;
  FLegGradientKind.OnChange := @DoLegAppFillChange;
  {$IFDEF WEBLIB}
  FLegFillCol1.OnSelect := @DoLegAppFillChange;
  FLegFillCol2.OnSelect := @DoLegAppFillChange;
  FLegStrokeCol.OnSelect := @DoLegAppStrokeChange;
  FLegFontCol.OnSelect := @DoLegAppFontChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FLegFillCol1.OnChange := @DoLegAppFillChange;
  FLegFillCol2.OnChange := @DoLegAppFillChange;
  FLegStrokeCol.OnChange := @DoLegAppStrokeChange;
  FLegFontCol.OnChange := @DoLegAppFontChange;
  {$ENDIF}
  FLegStrokeWidth.OnChange := @DoLegAppStrokeChange;
  FLegStrokeKind.OnChange := @DoLegAppStrokeChange;

  FLegFontName.OnChange := @DoLegAppFontChange;
  FLegSize.OnChange := @DoLegAppFontChange;

  {$IFDEF FMXLIB}
  FLegVisibleCheck.OnChange := @DoLegAppPosChange;
  FLegFillOpacity.OnChange := @DoLegAppFillChange;
  FLegStrokeOpacity.OnChange := @DoLegAppStrokeChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegVisibleCheck.OnClick := @DoLegAppPosChange;
  {$ENDIF}
end;

function TTMSFNCChartLegendEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartLegendEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartLegendEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;
  {$IFDEF VCLLIB}
  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

//    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
//    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
//    begin
//      fc := clr;
////      okfntCol := clr;
//    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];

  FLegendPanel.StyleElements := FLegendPanel.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  {$ENDIF}

  SetEditorOKButtonAppearance(FButtonOk,primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonCancel, primCol, EDITORBUTTONROUNDING, fntCol, fillCol);

  SetEditorSubPanelAppearance(FLegendPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
end;

procedure TTMSFNCChartLegendEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

{$IFDEF FMXLIB}
{ TTMSFNCChartAppearanceEditorSpinEdit }

constructor TTMSFNCChartLegendEditorSpinEdit.Create(AOwner: TComponent);
begin
  inherited;
  Max := 100000;
  Min := -100000;
end;
{$ENDIF}

{$IFDEF CMNWEBLIB}
constructor TTMSFNCChartLegendEditorComboBox.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF VCLLIB}
  {$IF COMPILERVERSION > 34}
  AutoDropDownWidth := True;
  {$IFEND}
  {$ENDIF}
end;

procedure TTMSFNCChartLegendEditor.SetColorComboStyle(AColorcombo: TTMSFNCChartLegendEditorColorCombo);
begin
  {$IFNDEF WEBLIB}
  AColorcombo.Style := [cbStandardColors, cbExtendedColors, cbCustomColor];
  {$ENDIF}
end;
{$ENDIF}

{$IFDEF WEBLIB}

{ TTMSFNCChartLegendEditorForm }

constructor TTMSFNCChartLegendEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartLegendEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartLegendEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
  end;
end;

procedure TTMSFNCChartLegendEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;
{$ENDIF}

end.
